import React from 'react';

import { AlertType } from '../../../../../enums/alert-type';
import { FormattedMessage } from 'react-intl';

import { AutoShipFbaError } from './auto-ship-fba-error';
import { AutomationRuleAction } from './automation-rule-action';
import { ConfigureStore } from './configure-store';
import { InventoryThresholdWarning } from './inventory-threshold-warning';
import '../../prop-types/alert.types';
import { LocalDeliveryExceptionAlert } from './local-delivery-exception';
import { MergeCustomer } from './merge-customer';
import { NewProducts } from './new-products';
import { OrdersDeallocated } from './orders-deallocated';
import { OrdersRejected } from './orders-rejected';
import { RejectedFulfillment } from './rejected-fulfillment';
import { ReturnsImport } from './returns-import';
import { ShipTogether } from './ship-together';
import { messages } from '../alert-type/messages';

/**
 * @param {AlertPropType} alert
 * @param {() => void} closeModal
 * @returns {JSX.Element}
 */
const renderDescription = (alert, closeModal) => {
  const {
    alertType,
    alertID,
    combineOrderCount,
    customerName,
    newProductCount,
    batchID,
    batchNumber,
    newReturnsCount,
    updatedReturnsCount,
    storeName,
    storeID,
    insufficientInventorySKUs,
    orderNumber,
    content,
    customerEmail,
    salesOrderID,
  } = alert;
  switch (alertType) {
    case AlertType.CONFIGURE_STORE:
      return <ConfigureStore storeID={storeID} storeName={storeName} />;
    case AlertType.SHIP_TOGETHER:
      return <ShipTogether alertID={alertID} closeModal={closeModal} combineOrderCount={combineOrderCount} customerName={customerName} />;
    case AlertType.NEW_PRODUCTS:
      return <NewProducts closeModal={closeModal} newProductCount={newProductCount} />;
    case AlertType.AUTOMATION_RULE_ACTION:
      return <AutomationRuleAction content={content} orderNumber={orderNumber} salesOrderID={salesOrderID} />;
    case AlertType.AUTO_SHIP_FBA_ERROR:
      return <AutoShipFbaError batchID={batchID} batchNumber={batchNumber} />;
    case AlertType.RETURNS_IMPORT:
      return <ReturnsImport newReturnsCount={newReturnsCount} storeName={storeName} updatedReturnsCount={updatedReturnsCount} />;
    case AlertType.ORDER_REJECTED:
      return <OrdersRejected insufficientInventorySKUs={insufficientInventorySKUs} storeName={storeName} />;
    case AlertType.MERGE_CUSTOMER:
      return <MergeCustomer customerEmail={customerEmail} customerNames={customerName} />;
    case AlertType.INVENTORY_THRESHOLD_WARNING:
      return <InventoryThresholdWarning content={content} />;
    case AlertType.LOCAL_DELIVERY_EXCEPTION:
      return <LocalDeliveryExceptionAlert content={content} orderNumber={orderNumber} salesOrderId={salesOrderID} />;
    case AlertType.ORDERS_DEALLOCATED:
      return <OrdersDeallocated content={content} />;
    case AlertType.REJECTED_FULFILLMENT:
      return <RejectedFulfillment closeModal={closeModal} orderNumber={orderNumber} storeName={storeName} />;
    default:
      return <FormattedMessage {...messages.Undetermined} />;
  }
};

/**
 * @param {object} props
 * @param {AlertPropType} props.alert
 * @param {() => void} props.closeModal
 * @returns {JSX.Element}
 */
export const AlertDescription = ({ alert, closeModal }) => {
  return <div>{renderDescription(alert, closeModal)}</div>;
};
